import React, { useEffect, useState } from 'react';
import intestazioniTablet from '../utils/chiaveDispositivo';
import '../styles/AvvisoCap.css';

/**
 * AvvisoCap — il CAP scritto e' di un altro comune? Un avviso, mai un
 * blocco (Alex, 26/09/2026: «le coppie incoerenti si riportano, non si
 * correggono da sole»; dalle prove dei percorsi, NOTA 1).
 *
 * La regola sta sul server (GET /api/comuni/verifica-cap): la tabella ha
 * un CAP solo per comune, e si avvisa solo quando il CAP appartiene a un
 * ALTRO comune, non quando la tabella non lo conosce. Qui si mostra e basta.
 *
 * Props: cap, comune, chiave (solo sul tablet), attivo (solo in Italia).
 */
const AvvisoCap = ({ cap, comune, chiave, attivo = true }) => {
    const [altri, setAltri] = useState(null);

    useEffect(() => {
        setAltri(null);
        if (!attivo || !/^\d{5}$/.test(String(cap || '')) || !String(comune || '').trim()) return undefined;
        let vivo = true;
        const t = setTimeout(async () => {
            try {
                const intestazioni = intestazioniTablet(chiave);
                if (!chiave) {
                    const token = localStorage.getItem('token');
                    if (token) intestazioni.Authorization = `Bearer ${token}`;
                }
                const par = new URLSearchParams({ cap, comune }).toString();
                const r = await fetch(`/api/comuni/verifica-cap?${par}`, { headers: intestazioni });
                const d = await r.json();
                if (vivo && d?.data?.coerente === false) setAltri(d.data.comuni_del_cap || []);
            } catch (e) { /* un avviso che non arriva non ferma nessuno */ }
        }, 300);
        return () => { vivo = false; clearTimeout(t); };
    }, [cap, comune, chiave, attivo]);

    if (!altri) return null;
    return (
        <span className="avviso-cap">
            Il CAP {cap} risulta di {altri.join(', ')}, non di {comune}: controlla.
        </span>
    );
};

export default AvvisoCap;
